import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, Spinner } from 'reactstrap'
import Header from '../../Header'
import LoadingAbsolute from '../../LoadingAbsolute'
import InputDisabled from '../../InputDisabled'
import MeslekModal from './MeslekModal'
import ArrowDownSvg from '../../../assets/icons/ArrowDownSvg'
import InputComp from '../../InputComp'
import axios from 'axios'
import { IconAlertSquareRoundedFilled } from '@tabler/icons-react'
import useErrorModal from '../../../hooks/useErrorModal'
import ErrorModal from '../../ErrorModal'

const HobiBahceleriForm = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const { isVisible: errorIsVisible, message: errorMessage, showError, closeError: errorCloseError } = useErrorModal()
  const [loading, setLoading] = useState(true)
  const [meslekModalOpen, setMeslekModalOpen] = useState(false)
  const [user, setUser] = useState({
    name: '',
    surname: '',
    TC: '',
    phone: '',
    ikamet: 'Yükleniyor',
  })
  const [selectedMeslek, setSelectedMeslek] = useState('')
  const [meslekler, setMeslekler] = useState([])
  const [meslekInputClass, setMeslekInputClass] = useState('selectInput')
  const [diger, setDiger] = useState('')
  const [isyeri, setIsyeri] = useState('')
  const [dogumTarihi, setDogumTarihi] = useState(null)
  const [unemployed, setUnemployed] = useState(false)
  const [InputDigerError, setInputDigerError] = useState(false)

  const getData = () => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/hobi-bahceleri-basvuru`, {
        // axios
        //   .get(`http://10.110.4.45:4000/test`, {
        headers: {
          Authorization: JSON.parse(localStorage.getItem('token')),
        },
      })
      .then((res) => {
        setLoading(false)
        if (res.data.success) {
          setMeslekler(res.data.user?.jobs)
          const user = res.data.user
          setUser({
            name: user?.adi,
            surname: user?.soyadi,
            TC: user?.tc,
            phone: user?.telefon_no,
            ikamet: user?.ikametgah_adresi,
          })
          if (user?.meslek) {
            // Gelen veri
            if (user.meslek?.id === 6) {
              setDiger(user.meslek?.diger)
            }
            setSelectedMeslek(user.meslek)
          }
          if (user?.issiz_mi) {
            setIsyeri(null)
            setUnemployed(true)
          } else {
            setIsyeri(user?.isyeri)
            setUnemployed(false)
          }
        } else if (res.data.code === 400) {
          alert('error1')
          // setWarningModalOpen({
          //   state: 'responseMessage',
          //   active: true,
          //   message: res.data.message,
          // })
        }
      })
      .catch((err) => {
        alert(JSON.stringify(err.response))
      })
  }

  useEffect(() => {
    getData()
  }, [state])

  return (
    <>
      {loading ? <LoadingAbsolute text={'Yükleniyor'} /> : null}
      <div className='hide-scrollbar'>
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 999,
          }}
        >
          <Header onClick={() => navigate(-1)} />
        </div>
        {!user?.ikamet ? (
          <div className='p-4'>
            <div className='alert alert-danger' role='alert'>
              <div className='text-center'>
                <IconAlertSquareRoundedFilled color='#A31D1D' size={48} className='mb-2' />
              </div>
              <div className='text-center'>
                Hobi bahçesi başvuruları sadece Karatay ilçesinde ikamet eden vatandaşlarımız için geçerlidir. İkametgah adresiniz Karatay olmasına rağmen hata alıyorsanız 444 9 332 numaralı hattan 1077 dahilisine bağlanarak bilgi
                verebilirsiniz.
              </div>
            </div>
          </div>
        ) : null}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
          }}
        >
          <>
            <div className='userInfoDiv'>
              <div className='form-input-div'>
                <InputDisabled label={'Adınız'} value={user?.name} />
              </div>
              <div className='form-input-div'>
                <InputDisabled label={'Soyadınız'} value={user?.surname} />
              </div>
              <div className='form-input-div'>
                <InputDisabled label={'T.C. Kimlik Numaranız'} value={user?.TC} />
              </div>
              <div className='form-input-div'>
                <InputDisabled label={'Telefonunuz'} value={user?.phone} />
              </div>
              {user?.ikamet ? <InputDisabled label={'İkametgah Adresiniz'} value={user?.ikamet} textArea={true} /> : null}
              {!user?.ikamet ? (
                <div className='form-input-div'>
                  <InputComp
                    label={'Doğum Tarihi'}
                    type='date'
                    value={dogumTarihi}
                    onChange={(e) => {
                      let value = e.target.value
                      setDogumTarihi(value)
                    }}
                    placeholder='Doğum Tarihi Yazınız...'
                  />
                </div>
              ) : null}
            </div>
            <div className={'userInfoDiv ' + (unemployed ? ' mt-4' : '')}>
              {!unemployed ? (
                <InputComp
                  label={'İş Yeri Adı'}
                  type='text'
                  value={isyeri}
                  onChange={(e) => {
                    let value = e.target.value
                    if (value.match(/\d/g)) {
                      value = value.replace(/\d/g, '')
                    }
                    setInputDigerError(false)
                    setIsyeri(value)
                  }}
                  placeholder='İş Yeri Adı Yazınız...'
                  error={InputDigerError}
                />
              ) : null}
              <label className='custom-checkbox-wrapper'>
                <input
                  type='checkbox'
                  style={{ display: 'none' }}
                  checked={unemployed}
                  onChange={() => {
                    if (unemployed) {
                      setSelectedMeslek('')
                      setDiger('')
                    }
                    setUnemployed(!unemployed)
                  }}
                />
                <span className='custom-checkmark'></span>
                <div className='hobiListItemDesc'>Çalışmıyorum</div>
              </label>
            </div>
            <div
              style={{
                margin: '1rem 1.5rem 0 1.5rem',
                width: '100%',
              }}
            >
              <div className='selectLabel'>Mesleğiniz</div>
              <div className={meslekInputClass} onClick={() => setMeslekModalOpen(true)}>
                <div>{selectedMeslek ? selectedMeslek.name : 'Seçiniz'}</div> <ArrowDownSvg width={'1rem'} height={'1rem'} stroke={meslekInputClass === 'unSelectInput' ? 'red' : '#b5ccc2'} />
              </div>
              {meslekInputClass === 'unSelectInput' && (
                <div
                  style={{
                    marginLeft: '0.5rem',
                    fontSize: '9px',
                    color: 'red',
                  }}
                >
                  * Bu Alan Zorunludur.
                </div>
              )}
              <div className='hobiDigerInfo'>* Listede olmayan meslek grubu için diğer seçeneğini seçiniz.</div>
            </div>
            {selectedMeslek?.id === 6 && (
              <div className='userInfoDiv'>
                <InputComp
                  label={'Diğer'}
                  type='text'
                  value={diger}
                  onChange={(e) => {
                    let value = e.target.value
                    if (value.match(/\d/g)) {
                      value = value.replace(/\d/g, '')
                    }
                    // const digerValid = meslekler?.find((item) => {
                    //   const normalizedMain = item.name
                    //     .toLocaleLowerCase('tr')
                    //     .normalize('NFC')
                    //   const normalizedSearch = value
                    //     .toLocaleLowerCase('tr')
                    //     .normalize('NFC')

                    //   return normalizedMain.includes(normalizedSearch)
                    // })

                    // console.log('digerValid: ', digerValid)
                    // console.log('selectedMeslek: ', selectedMeslek)
                    setInputDigerError(false)
                    setDiger(value)
                  }}
                  placeholder='Mesleğinizi Yazınız...'
                  error={InputDigerError}
                />
              </div>
            )}
          </>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '1rem',
            marginBottom: '2rem',
          }}
        >
          <Button
            block
            onClick={() => {
              if (!selectedMeslek) {
                setMeslekInputClass('unSelectInput')
              } else if (selectedMeslek?.id === 6 && !diger?.length) {
                setInputDigerError(true)
              } else {
                setInputDigerError(false)
                setMeslekInputClass('selectInput')
                let meslek = ''
                if (selectedMeslek?.id === 6 && diger?.length) {
                  meslek = diger[0]
                } else {
                  meslek = selectedMeslek?.name
                }
                if (state?.ucret > 0) {
                  navigate('/hobiOdeme', {
                    state: {
                      meslek: meslek,
                      unemployed: unemployed,
                      isyeri: isyeri,
                      ucret: state?.ucret,
                    },
                  })
                } else {
                  setLoading(true)
                  let parameter_data = { job: meslek, unemployed: unemployed, business: isyeri }
                  if (!user?.ikamet) {
                    parameter_data = { job: meslek, unemployed: unemployed, business: isyeri, birthdate: dogumTarihi }
                  }
                  axios
                    .post(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/hobi-bahceleri-basvuru`, parameter_data, {
                      headers: {
                        Authorization: JSON.parse(localStorage.getItem('token')),
                      },
                    })
                    .then((res) => {
                      setLoading(false)
                      navigate('/hobiSuccess', {
                        state: {
                          id: res.data.id,
                        },
                      })
                    })
                    .catch((err) => {
                      console.log('err:', err)
                      showError(err?.response?.data?.message)
                    })
                    .finally(() => {
                      setLoading(false)
                    })
                }
              }
            }}
            style={{
              marginLeft: '1rem',
              marginRight: '1rem',
              backgroundColor: '#285843',
              borderRadius: '50px',
              padding: '.5rem 0',
            }}
          >
            {loading ? (
              <Spinner
                size={'sm'}
                // type="grow"
              />
            ) : state?.ucret > 0 ? (
              'Ödeme İşlemine Devam Et'
            ) : (
              'Başvur'
            )}
          </Button>
        </div>
      </div>
      <MeslekModal show={meslekModalOpen} onHide={() => setMeslekModalOpen(false)} setMeslek={setSelectedMeslek} setMeslekInputClass={setMeslekInputClass} meslekler={meslekler} />
      <ErrorModal isVisible={errorIsVisible} onClose={errorCloseError} message={errorMessage} />
    </>
  )
}

export default HobiBahceleriForm
